import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import AddressListItem from './AddressListItem';

const AddressListItemContainer = ({ address, onClickOrder, ...props }) => {
  const handleClickOrder = useCallback(() => onClickOrder(address), [onClickOrder, address]);
  return <AddressListItem {...props} address={address} onClickOrder={handleClickOrder} />;
};

AddressListItemContainer.propTypes = {
  address: PropTypes.object,
  onClickOrder: PropTypes.func,
};

export default AddressListItemContainer;
